/** Split group admission and typed display limits, shared by client and server. */
export const MAX_SPLIT_MEMBERS = 30;
export const MAX_LIVE_SPLIT_INVITES = 5;
export const SPLIT_WRONG_CODE_LIMIT = 5;
export const SPLIT_PREVIEW_LIMIT = 100;
export const SPLIT_LABEL_MAX_LENGTH = 40;
export const SPLIT_ID_MAX_LENGTH = 128;
